


import { MenuItem } from "@/types/menu";
import { PublicMenuSearchFilters } from "../PublicMenuSearchFilters";
import { MenuItemList } from "../MenuItemList";
import { useTranslation } from "react-i18next";

interface MenuContentTabProps {
  menuItems: MenuItem[];
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  selectedTags: string[];
  categories: { id: string; name: string }[];
  onViewDetails: (item: MenuItem) => void;
  onAddToCart: (item: MenuItem) => void;
  setShowTagsFilter: (show: boolean) => void;
}

export function MenuContentTab({
  menuItems,
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  selectedTags,
  categories,
  onViewDetails,
  onAddToCart,
  setShowTagsFilter,
}: MenuContentTabProps) {
  const { t } = useTranslation();

  // Handle add to cart by dispatching a custom event
  const handleAddToCart = (item: MenuItem) => {
    const event = new CustomEvent('add-to-cart', { detail: item });
    window.dispatchEvent(event);
  };

  const filteredItems = menuItems?.filter((item) => {
    const searchTermLower = searchTerm.toLowerCase();
    const itemNameLower = item.name.toLowerCase();
    const itemDescriptionLower = item.description?.toLowerCase() || "";

    const matchesSearchTerm =
      itemNameLower.includes(searchTermLower) ||
      itemDescriptionLower.includes(searchTermLower);

    const matchesCategory =
      selectedCategory === "all" || item.categoryIds?.includes(selectedCategory);

    const matchesTags =
      selectedTags.length === 0 ||
      (item.tags || []).some((tag) => selectedTags.includes(tag));

    return matchesSearchTerm && matchesCategory && matchesTags;
  });

  // Convert MenuItem[] to MenuItemWithCategory[] by ensuring categoryIds is present
  const filteredItemsWithCategories = filteredItems.map(item => ({
    ...item,
    categoryIds: item.categoryIds || [],
  }));

  return (
    <div className="tab-content" data-tab="menu">
      <PublicMenuSearchFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedTags={selectedTags}
        setSelectedTags={() => {}} // Empty function since we handle this at parent level
        categories={categories.map(cat => ({
          id: cat.id,
          name: cat.name,
          store_id: '', // Add required store_id property
          description: '', // Add required description property
        }))}
        setShowTagsFilter={setShowTagsFilter}
      />

      <MenuItemList
        items={filteredItemsWithCategories}
        onViewDetails={onViewDetails}
        onAddToCart={handleAddToCart}
        searchTerm={searchTerm}
        selectedCategory={selectedCategory}
        selectedTags={selectedTags}
      />
    </div>
  );
}


